
<kendo-grid [data]="gridData" 
  [hideHeader]="true"
  [size]="'small'"
  [height]="265"
  [loading]="isloading"
  kendoGridSelectBy="id" 
  [selectable]="selectableSettings" 
  [(selectedKeys)]="mySelection"
>
  <kendo-grid-column field="combinedTime" title="час"> </kendo-grid-column>
  <kendo-grid-column field="date" title="" >
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button kendoButton fillMode="outline" (click)="mySelection = [ dataItem.id ]; queueSelected.emit(dataItem)">Записатися</button>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-messages noRecords="На обрану дату прийом відсутній. Оберіть іншу дату."> </kendo-grid-messages>
</kendo-grid>
 
